import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  getAllCoaches,
  getAllOrganizations,
  getOrganizationReport,
} from "../../redux/actions/authAction";

const OrganizationReport = () => {
  const dispatch = useDispatch();

  const { allCoaches } = useSelector((state) => state.getManageCoachesData);
  const { allOrganizations } = useSelector(
    (state) => state.getOrganizationData
  );
  const { organizationReportData } = useSelector(
    (state) => state.getReportsData
  );
  const [organizationFilter, setOrganizationFilter] = useState(
    allOrganizations?.data?.[0]?._id
  );

  useEffect(() => {
    dispatch(getOrganizationReport(organizationFilter));
  }, [organizationFilter]);
  return (
    <>
      <>
        <ToastContainer />
      </>
      <div className="manage-user">
        <div className="row mb-3 pt-5 pl-5">
          <div className="col-md-6">
            <h1 className="healthKitUpdateHeaderFont d-flex">
              Organization's Report
            </h1>
          </div>
        </div>
        <div className="organization-report-main">
          {allOrganizations?.data?.length ? (
            <>
              <div className="organization-report-filter">
                <Form.Label className="d-flex organization-report-filter-heading">
                  Organizations
                </Form.Label>
                <Form.Select
                  onChange={(e) => setOrganizationFilter(e.target.value)}
                  aria-label="Default select example"
                  value={organizationFilter}
                >
                  {/* <option value="">Select Organization</option> */}
                  {allOrganizations?.data?.map((organization, index) => {
                    return (
                      <option value={organization?._id}>
                        {organization?.organizationName}
                      </option>
                    );
                  })}
                </Form.Select>
              </div>
              <div className="organization-overall-report pt-5">
                <div className="average-score">
                  <p>
                    Average score of all employees :{" "}
                    {organizationReportData?.data?.usersTotalScore} %
                  </p>{" "}
                </div>
              </div>
              <div className="report-engagement-heading">
                <p>Domain wise engagement of employees</p>
              </div>
              <div className="organization-report-page mt-5">
                <>
                  <div className="organization-report-table">
                    {allCoaches?.data ? (
                      <>
                        <table>
                          <thead>
                            <tr
                              className="header-row"
                              style={{ margin: "10px", height: "50px" }}
                            >
                              <th
                                style={{
                                  width: "360px",
                                  paddingLeft: "30px",
                                  textAlign: "left",
                                  position: "static",
                                }}
                              >
                                Domain
                              </th>
                              <th
                                style={{
                                  textAlign: "left",
                                  width: "300px",
                                  position: "static",
                                }}
                              >
                                Engagement percentage
                              </th>
                            </tr>
                          </thead>

                          <>
                            <tbody>
                              <tr
                                className="whole-row-client"
                                style={{
                                  borderBottom: "1px solid #f1f5f9",
                                }}
                              >
                                <td className="pic-name-in-table">
                                  <div
                                    style={{
                                      paddingTop: "15px",
                                      paddingLeft: "22px",
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    Physical Health
                                  </div>
                                </td>

                                <td>
                                  <div
                                    className="d-grid gap-2 d-md-block"
                                    style={{
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <div style={{ color: "blue" }}>
                                      {
                                        organizationReportData?.data
                                          ?.physicalTotalScore
                                      }{" "}
                                      %
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                className="whole-row-client"
                                style={{
                                  borderBottom: "1px solid #f1f5f9",
                                }}
                              >
                                <td className="pic-name-in-table">
                                  <div
                                    style={{
                                      paddingTop: "15px",
                                      paddingLeft: "22px",
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    Emotional Health
                                  </div>
                                </td>

                                <td>
                                  <div
                                    className="d-grid gap-2 d-md-block"
                                    style={{
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <div style={{ color: "blue" }}>
                                      {
                                        organizationReportData?.data
                                          ?.emotionalTotalScore
                                      }{" "}
                                      %
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                className="whole-row-client"
                                style={{
                                  borderBottom: "1px solid #f1f5f9",
                                }}
                              >
                                <td className="pic-name-in-table">
                                  <div
                                    style={{
                                      paddingTop: "15px",
                                      paddingLeft: "22px",
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    Healthy Behaviour
                                  </div>
                                </td>

                                <td>
                                  <div
                                    className="d-grid gap-2 d-md-block"
                                    style={{
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <div style={{ color: "blue" }}>
                                      {
                                        organizationReportData?.data
                                          ?.healthyBehaviourTotalScore
                                      }{" "}
                                      %
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                className="whole-row-client"
                                style={{
                                  borderBottom: "1px solid #f1f5f9",
                                }}
                              >
                                <td className="pic-name-in-table">
                                  <div
                                    style={{
                                      paddingTop: "15px",
                                      paddingLeft: "22px",
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    Work Emvironment
                                  </div>
                                </td>

                                <td>
                                  <div
                                    className="d-grid gap-2 d-md-block"
                                    style={{
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <div style={{ color: "blue" }}>
                                      {
                                        organizationReportData?.data
                                          ?.workEnvironmentTotalScore
                                      }{" "}
                                      %
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                className="whole-row-client"
                                style={{
                                  borderBottom: "1px solid #f1f5f9",
                                }}
                              >
                                <td className="pic-name-in-table">
                                  <div
                                    style={{
                                      paddingTop: "15px",
                                      paddingLeft: "22px",
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    Basic Access
                                  </div>
                                </td>

                                <td>
                                  <div
                                    className="d-grid gap-2 d-md-block"
                                    style={{
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <div style={{ color: "blue" }}>
                                      {
                                        organizationReportData?.data
                                          ?.basicAccessTotalScore
                                      }{" "}
                                      %
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                className="whole-row-client"
                                style={{
                                  borderBottom: "1px solid #f1f5f9",
                                }}
                              >
                                <td className="pic-name-in-table">
                                  <div
                                    style={{
                                      paddingTop: "15px",
                                      paddingLeft: "22px",
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    Life Evaluation
                                  </div>
                                </td>

                                <td>
                                  <div
                                    className="d-grid gap-2 d-md-block"
                                    style={{
                                      textAlign: "left",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <div style={{ color: "blue" }}>
                                      {
                                        organizationReportData?.data
                                          ?.lifeEvaluationTotalScore
                                      }{" "}
                                      %
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </>
                        </table>
                      </>
                    ) : (
                      <h3>No Guides yet</h3>
                    )}
                  </div>
                </>
              </div>
              <div className="report-engagement-heading">
                <p>Goals wise engagement of employees</p>
              </div>
              <div className="organization-report-page mt-5">
                <>
                  <div className="organization-report-table">
                    {organizationReportData?.data?.goalsData?.length ? (
                      <>
                        <table>
                          <thead>
                            <tr
                              className="header-row"
                              style={{ margin: "10px", height: "50px" }}
                            >
                              <th
                                style={{
                                  width: "360px",
                                  paddingLeft: "30px",
                                  textAlign: "left",
                                  position: "static",
                                }}
                              >
                                Goals
                              </th>
                              <th
                                style={{
                                  // textAlign: "left",
                                  width: "300px",
                                  position: "static",
                                }}
                              >
                                Engagement percentage
                              </th>
                              <th
                                style={{
                                  // textAlign: "left",
                                  width: "300px",
                                  position: "static",
                                }}
                              >
                                User selection
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {organizationReportData?.data?.goalsData?.map(
                              (data, index) => {
                                return (
                                  <>
                                    <tr
                                      className="whole-row-client"
                                      style={{
                                        borderBottom: "1px solid #f1f5f9",
                                      }}
                                    >
                                      <td className="pic-name-in-table">
                                        <div
                                          style={{
                                            paddingTop: "15px",
                                            paddingLeft: "22px",
                                            textAlign: "left",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {data?.title}
                                        </div>
                                      </td>

                                      <td>
                                        <div
                                          className="d-grid gap-2 d-md-block"
                                          style={{
                                            // textAlign: "left",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          <div style={{ color: "blue" }}>
                                            {data?.percentage}%
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <div
                                          className="d-grid gap-2 d-md-block"
                                          style={{
                                            // textAlign: "left",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          <div style={{ color: "blue" }}>
                                            {data?.count}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                );
                              }
                            )}
                          </tbody>
                        </table>{" "}
                        <div
                          style={{
                            width: "100%",
                            textAlign: "right",
                            paddingRight: "10%",
                          }}
                        >
                          Total count:{" "}
                          {
                            organizationReportData?.data?.goalsData[0]
                              ?.totalCount
                          }
                        </div>
                      </>
                    ) : (
                      <div className="No-data-statement">
                        {" "}
                        <h4>No Goals yet</h4>
                      </div>
                    )}
                  </div>
                </>
              </div>
            </>
          ) : (
            <div className="No-data-statement">
              {" "}
              <h3>No Organizations yet</h3>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OrganizationReport;
